<template>
    <div class="btn flex-y-center" @click="Toggle()">
        <img class="checkbox" :src="Source().source" :alt="Source().label" :title="Source().label" width="25" height="25"/>
        <span class="label">{{ label }}</span>
    </div>
</template>

<script>
export default {
    name: "Checkbox",
    props: {
        selected: Boolean,
        label: String,
        index: Number
    },
    methods: {
        Toggle: function() {
            this.$emit("toggle", {
                selected: !this.selected,
                value: this.label,
                index: this.index
            });
        },
        Source: function() {
            const source = this.selected ? "CheckboxActive.png" : "CheckboxInactive.png";
            return {
                source: require(`@/assets/Images/${source}`),
                label:  this.selected ? "Checkbox - Active" : "Checkbox - Inactive"
            };
        }
    },
    emits: [ "toggle" ]
};
</script>